import React from 'react';
import { FormControl } from 'react-bootstrap';

const ActivatePublish = ({ comment, onCommentChanged }) => (
    <React.Fragment>
        <p>
            Publishing this Flow will make this version of the Flow the default version.
            This will be the version of the Flow that users will run if a Flow Version Id is
            <strong> not </strong>
            specified
        </p>
        <FormControl
            componentClass="textarea"
            placeholder="Enter a comment for this version"
            rows="3"
            value={comment}
            onChange={onCommentChanged}
        />
    </React.Fragment>
);

export default ActivatePublish;
